import React from "react"

const stripHtml = text =>
  text
    .replace(/<[^>]*>/g, " ")
    .replace(/\s+/g, " ")
    .trim()

const plainTextFromAnswer = answer => {
  if (typeof answer === "string") {
    return stripHtml(answer)
  }

  if (answer && typeof answer === "object") {
    const text = Object.values(answer)
      .filter(part => typeof part === "string")
      .join(" ")

    return text ? stripHtml(text) : null
  }

  return null
}

const plainTextFromPortableText = blocks => {
  if (!Array.isArray(blocks)) {
    return ""
  }

  return blocks
    .map(block => {
      if (block._type !== "block" || !block.children) {
        return ""
      }

      return block.children.map(child => child.text || "").join("")
    })
    .filter(Boolean)
    .join(" ")
}

const getAnswerTextFromItem = item => {
  let answer =
    item.answer ??
    (typeof item.description === "string" ? item.description : null) ??
    (item._rawContent ? plainTextFromPortableText(item._rawContent) : null)

  if (!answer) {
    return null
  }

  if (item.list?.length) {
    answer = [answer, item.list.join(" ")].join(" ")
  }

  return plainTextFromAnswer(answer)
}

export const getFaqAnswerText = item => getAnswerTextFromItem(item)

export { plainTextFromPortableText }

export const plainTextFromChildren = children => {
  const text = React.Children.toArray(children)
    .map(child => {
      if (child === null || child === undefined || typeof child === "boolean") {
        return ""
      }

      if (typeof child === "string" || typeof child === "number") {
        return String(child)
      }

      if (React.isValidElement(child)) {
        return plainTextFromChildren(child.props.children)
      }

      return ""
    })
    .join(" ")

  return text ? stripHtml(text) : null
}

export const buildFaqPageSchema = items => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: items.map(({ question, answer }) => ({
    "@type": "Question",
    name: question,
    acceptedAnswer: {
      "@type": "Answer",
      text: answer,
    },
  })),
})
